<template>
  <div>
    <!-- :value="currentGroup.title" -->

    <Input
      search
      enter-button="选择分类"
      placeholder="选择分类"
      :value="currentNode.title"
      @on-search="typeChoose"
      readonly
      @on-focus="typeChoose"
    />
    <Modal
      v-model="treeChooseShow"
      scrollable
      title="请选择分类"
      @on-ok="questionGroupConfirm"
    >
      <mytree
        :treeData="questionTypeTree"
        @eventUp="treeEvent"
        :showCheckbox="showCheckbox"
      ></mytree>
    </Modal>
  </div>
</template>

<script>
import mytree from "@/component/tree/mytree.vue";
import treeVue from "../../views/my-components/other/tree/tree.vue";

export default {
  props: {
    questionTypeTree: Array,
    currentGroup: {
      type: Object,
      default: () => {
        return { title: "无分类" };
      },
    },
    currentNodeId: {
      type: Number,
      default: 0,
    },
    showCheckbox: { type: Boolean, default: false },
  },
  components: { mytree },
  data() {
    return {
      treeChooseShow: false,
    };
  },
  watch: {
    currentGroup: {
      handler(...a) {
        console.log(a);
      },
      deep: true,
    },
  },
  computed: {
    currentNode() {
      let returnItem = null;
      let that = this;
      this.questionTypeTree.forEach(function treeMaker(item) {
        if (item.id == that.currentNodeId) {
          returnItem = item;
        }
        if (item.children && item.children.length > 0) {
          item.children.forEach((nextItem) => treeMaker(nextItem));
        }
      });
      return returnItem || { title: "无分类" };
    },
  },
  created() {},
  mounted() {
    setTimeout(() => {
      console.log(this.currentGroup);
    }, 2000);
  },
  methods: {
    treeEvent(...data) {
      this.$emit("treeEvent", ...data);
    },
    typeChoose() {
      this.treeChooseShow = true;
    },
    questionGroupConfirm() {
      let data = { type: "confirm" };
      this.$emit("treeEvent", data);
    },
  },
};
</script>

<style scoped lang="less">
</style>
